import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["text-label", { bold: _ctx.bold, italic: _ctx.italic, multiline: _ctx.multiline, 'table-align': _ctx.tableAlign }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}